// extracted by mini-css-extract-plugin
module.exports = {"mainContentWrapper":"styles_mainContentWrapper__1tO0U","tableContent":"styles_tableContent__1Sdq_"};